import { render, staticRenderFns } from "./DashBoardPanel.vue?vue&type=template&id=68c013d2&scoped=true"
import script from "./DashBoardPanel.vue?vue&type=script&lang=ts"
export * from "./DashBoardPanel.vue?vue&type=script&lang=ts"
import style0 from "./DashBoardPanel.vue?vue&type=style&index=0&id=68c013d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c013d2",
  null
  
)

export default component.exports